import script from "./RevealOnScroll.vue?vue&type=script&setup=true&lang=js"
export * from "./RevealOnScroll.vue?vue&type=script&setup=true&lang=js"

import "./RevealOnScroll.vue?vue&type=style&index=0&id=b6f28206&lang=css"

const __exports__ = script;

export default __exports__